var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5831 6.83334H23.0306C23.5494 6.82416 24.0535 7.0058 24.4472 7.34376C24.841 7.68172 25.0969 8.15248 25.1665 8.66667V15.0833C25.0969 15.5975 24.841 16.0683 24.4472 16.4063C24.0535 16.7442 23.5494 16.9258 23.0306 16.9167H20.5831M14.1665 18.75V22.4167C14.1665 23.146 14.4562 23.8455 14.9719 24.3612C15.4876 24.8769 16.1871 25.1667 16.9165 25.1667L20.5831 16.9167V6.83334H10.2431C9.80098 6.82834 9.37194 6.9833 9.03504 7.26967C8.69814 7.55603 8.47608 7.95451 8.40978 8.39167L7.14478 16.6417C7.1049 16.9044 7.12262 17.1727 7.19672 17.4279C7.27082 17.6832 7.39952 17.9192 7.57391 18.1198C7.7483 18.3203 7.96421 18.4806 8.20668 18.5894C8.44914 18.6982 8.71237 18.753 8.97812 18.75H14.1665Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdown);
export default __webpack_public_path__ + "static/media/thumbsdown.b711a8c5340a99a622751f8b7fdff31c.svg";
export { ForwardRef as ReactComponent };